import qs from 'qs'

export default {
    namespaced: true,
    state: {
        products: {},
        posts_per_page: 12,
        all_products: 12,
        show_btn_more: false
    },
    mutations: {
        products(state, items) {
            state.products = items
        },
        products_count(state, items_count) {
            state.all_products = items_count
        },
        get_more_posts(state) {
            state.posts_per_page += 3
        },
        change_btn_visibility(state) {
            state.show_btn_more = (state.posts_per_page < state.all_products)
        }
    },
    actions: {
        async getProductsList({commit, state}, cat_id) {
            commit('get_more_posts')
            let cats = 0;
            if (Number.isInteger(cat_id)) {
                cats = cat_id;
            } else if (cat_id.length !== undefined && cat_id.length > 0) {
                cats = cat_id.join(', ')
            } else {
                cats = 0
            }
            await this.axios.get(window.global.ajax, {
                params: {
                    action: 'get_products_list',
                    posts_per_page: state.posts_per_page,
                    category_id: cats,
                    headers: {
                        'content-type': 'application/json',
                    }
                }
            })
                .then((res) => {
                    if (res.data.success) {
                        commit('products', res.data.data.products);
                        commit('products_count', res.data.data.all_products_count);
                        commit('change_btn_visibility')
                    }
                }).catch((e) => {
                    console.log('error')
                })
        }
    },
    getters: {
        get_products: (state) => state.products,
        all_products: (state) => state.all_products,
        show_button: (state) => !state.show_btn_more
    }
};